export default "__VITE_ASSET__DNtMYfVO__"